export const isSitemapEntry = (str = '') => {
	const sitemapRegex = /^[A-Z0-9]+(?:_[A-Z0-9]+)*$/g;
	return sitemapRegex.test(str);
};
